import { Text } from "react-native-paper";
import type { Source } from "react-native-pdf";
import { Document, Page, pdfjs } from "react-pdf";

import "react-pdf/dist/cjs/Page/TextLayer.css";
import "react-pdf/dist/cjs/Page/AnnotationLayer.css";
import Box from "@memorang/ui/src/components/Box";
import Loader from "@memorang/ui/src/components/Loader";

// Configure pdf.js worker, using a direct CDN URL to avoid webpack issues
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const options = {
	cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
};

type Props = {
	pageNumber: number;
	source: Source;
	width?: number;
};

const PdfRenderer = ({ pageNumber, source, width = 900 }: Props) => {
	if (pageNumber === null) {
		return null;
	}

	return (
		<Box width="100%" height="100%" overflow="auto">
			<Document
				file={source.uri}
				loading={
					<Box
						justifyContent="center"
						alignItems="center"
						height="100%"
						width="100%"
					>
						<Loader />
					</Box>
				}
				error={<Text>Failed to load PDF</Text>}
				options={options}
			>
				<Page pageNumber={pageNumber ?? 1} width={width - 32} />
			</Document>
		</Box>
	);
};

export default PdfRenderer;
